<template>
  <div class="__modal-backdrop" v-if="show">
    <div class="__modal-wrapper">
      <div class="__modal" >
        <div class="__modal-header">
          <slot name="modal-header"></slot>
        </div>

        <div class="__modal-body">
          <slot name="modal-body"></slot>
        </div>

        <div class="__modal-footer">
          <slot name="modal-footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "Modal",
  props: {
    show: {
      type: Boolean,
      default: true ,
    },
  }, 
}
</script>

<style lang="scss" scoped>

html {
  position: relative;

  .__modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    z-index: 9999;

    .__modal-wrapper {
      position: relative;

        .__modal {
        position: absolute;
        z-index: 9999;
        background: #fff;
        max-width: 600px;
        top: 100px;
        left: 0;
        right: 0;
        margin: 0 auto;
        box-shadow: inset 0px 1px 0px #DDDDDD;
        border-radius: 4px;

        .__modal-header {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          background: #fff;
          padding: 15px 20px;

          // background: 
          h1 {
            font-size: 18px;
            font-weight: 600;
            color: #3C3E49;
            line-height: 28px;
          }
        }

        .__modal-body {
          padding: 16px 20px;
        }

        .__modal-footer {
          padding: 20px;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
  }
}

  
</style>